<script setup lang="ts">
const { loadLayout, layoutData } = useLayout()
await loadLayout()
</script>

<template>
  <div class="top-links">
    <ul
      v-if="layoutData?.serviceLinks?.[0]?.Items?.length"
      class="top-links__list"
    >
      <li
        v-if="$slots.before"
        class="top-links__item"
      >
        <slot name="before" />
      </li>

      <li
        v-for="item in layoutData?.serviceLinks?.[0]?.Items || []"
        :key="item.id"
        class="top-links__item"
      >
        <NuxtLink
          :to="item.Link"
          class="top-links__link"
        >{{ item.Name }}</NuxtLink>
      </li>

      <li
        v-if="$slots.after"
        class="top-links__item"
      >
        <slot name="after" />
      </li>
    </ul>
  </div>
</template>

<style>
@import url("~layers/components/Header/Links.css");
</style>
